import { Abacus } from "core/Abacus.Core";
import { Class } from "core/Abacus.Utilities";
import { Promise } from "es6-promise-polyfill";

$(function() {
    $(window).on('abacus:customwidget:complete', function(evt, context) {
        if (context.find('.widget-search-picker-masthead').length && !context.find('.widget-search-picker-masthead-applied').length) {
            let element = (context.find(".widget")[0] || context.is('.widget-search-picker-masthead') && context[0]);
            Abacus.WidgetSearchPicker = new WidgetSearchPicker(element);
        }
    });
});

class WidgetSearchPicker extends Class {
    constructor(element, options) {
        super();
        this.element = $(element);
        this.delay = (this.element.data('delay') || '3000');
        this.slidetimeout = (this.element.data('slideTimeout') || '1500');
        this.setOptions(options);
        this.setUpEvents();
    }

    setUpEvents() {
        var _that = this.element;
        var _delay = this.delay;
        var _slidetimeout = this.slidetimeout;

        if ($('#masthead + div > .widget-search-picker-masthead > .widget-container').length) {
            $(document.body).addClass('widget-search-picker-masthead-pushed');
            $(window).on("abacus:stickyelement:fixed", function(evt, context) {
                $(document.body).addClass('widget-search-picker-masthead-fixed');
            });
            $(window).on("abacus:stickyelement:unfixed", function(evt, context) {
                $(document.body).removeClass('widget-search-picker-masthead-fixed');
            });
        }

        if ($('#wrapper_sleeve .widget-search-picker-masthead .widget-search-picker-masthead-slider').length) {
            var sliderInverval, sliderInit = function() {
                    $('#wrapper_sleeve .widget-search-picker-masthead .widget-search-picker-masthead-slider').each(function(index, element) {
                        var _this = $(this);
                        $("div.slide:gt(0)", _this).hide();
                        sliderInverval = setInterval(function() {
                            $('div.slide:first', _this)
                                .fadeOut(_slidetimeout)
                                .next()
                                .fadeIn(_slidetimeout)
                                .end()
                                .appendTo(_this);
                        }, _delay);
                    });
                },
                init = function() {
                    if ($(window).width() >= 1024) {
                        sliderInit();
                    }
                };

            init();
            $(window).resize(function() {
                clearInterval(sliderInverval);
                init();
            });
        }

        $(this.element).addClass('widget-search-picker-masthead-applied');

        //apply tabindex
        $('.widget-search-picker-masthead-dropdown .dropdown-label').each(function(index, item) {
            $(item).not('[tabindex=-1]').attr('tabindex', 0);
            $('.widget-search-picker-masthead-controls-container .widget-search-picker-masthead-button.widget-button-search .button-search').not('[tabindex=-1]').attr('tabindex', 0);

        })


        // search widget toggle click
        $('body').on('click keypress', '.widget-search-picker-masthead-dropdown .dropdown-label', function(event) {
            event.preventDefault();
            let _that = $(this);
            if (event.keypress = 38) {
                _that.parents('.widget-search-picker-masthead-controls-container').find('.widget-search-picker-masthead-dropdown').each(function(index, elem) {
                    let _thatParent = _that.parents('.widget-search-picker-masthead-dropdown')[0];
                    if (elem !== _thatParent) {
                        elem.classList.remove('open');
                    }
                });
                _that.parents('.widget-search-picker-masthead-dropdown').toggleClass('open');

                $(_that).next().find('.dropdown-options-inner .dropdown-option .dropdown-option-checkbox label').each(function(index, item) {
                    $(_that).next().find('.dropdown-options-inner .dropdown-option .dropdown-option-checkbox label')[0].focus();
                    let count = $(_that).next().find('.dropdown-options-inner .dropdown-option .dropdown-option-checkbox label').length;
                    $(item).not('[tabindex=-1]').attr('tabindex', 0);
                    $(item).find('input').attr('tabindex', -1);
                    if (index == count - 1) {
                        $(this).on('focusout', function() {
                            _that.parents('.widget-search-picker-masthead-dropdown').removeClass('open');
                        })
                    }
                });

            }
        });
        // search widget dropdown hide if clicked outside
        $('body').on('click', function(event) {
            if (!$(event.target).parents('.widget-search-picker-masthead-dropdown').length) {
                $('body .widget-search-picker-masthead .widget-search-picker-masthead-dropdown').removeClass('open');
            }
        });

        $('body').on('click keypress', '.widget-search-picker-masthead-dropdown .dropdown-option-checkbox label', function(event) {
            event.preventDefault();
            let _input = $('input[type="checkbox"]', $(this).parents('.dropdown-option'));
            let _dd = _input.parents('.widget-search-picker-masthead-dropdown');
            let _counter = 0;

            if (_input.prop('checked')) {
                _input.removeAttr('checked').prop('checked', false).parents('.dropdown-option-checkbox').removeClass('checked');
            } else {
                _input.attr('checked', 'checked').prop('checked', true).parents('.dropdown-option-checkbox').addClass('checked');
            }

            _counter = _dd.find('.dropdown-options .dropdown-option-checkbox.checked').length;
            if (_counter) {
                _dd.find('.dropdown-label>.counter').html('(' + _counter + ')');
            } else {
                _dd.find('.dropdown-label>.counter').html('');
            }

        });

        // keyword enter click
        $('.widget-search-picker-masthead input.text[type="search"]').keypress(function(event) {
            var keycode = (event.keyCode ? event.keyCode : event.which);
            if (keycode == '13') {
                event.preventDefault();
                event.stopPropagation();
                $('.widget-search-picker-masthead-button>.button-search').trigger('click');
            }
        });

        $('body').on('click', '.widget-search-picker-masthead-container .button-search', function(event) {
            event.preventDefault();
            var $this = $(this);
            var $form = $this.parents('form');
            var $formElements = $('input[type="checkbox"]:checked', $form);
            var $qkeyword = $("input[name=qkeyword]", $form);
            var formURLParameters = [];
            $formElements.each(function(index, element) {
                var $element = $(element),
                    elemValue = $element.val();
                if (elemValue) {
                    var valueToAdd = element.name + "|" + elemValue;
                    if (formURLParameters.indexOf(valueToAdd) == -1) {
                        formURLParameters.push(valueToAdd);
                    }
                }
            });
            var formActionURL = $form.attr("action");
            window.location.href = formActionURL +
                (formActionURL.indexOf("?") != -1 ? "&" : "?") +
                (formActionURL.indexOf("qkeyword") == -1 ? "qkeyword=" + $qkeyword.val() + "&" : "") +
                "parametrics=" + encodeURIComponent(formURLParameters.join(","));
        });

        var showModal = function(content, title, closetext, primarybutton, secondarybutton) {
            var modalPopup = createModal(content, title, closetext, primarybutton, secondarybutton);
            $('body').append('<div class="widget-search-picker-modal-backdrop"></div>').append(modalPopup).addClass('widget-search-picker-modal-open');
            $(window).trigger("abacus:widget-search-picker-masthead:applied", modalPopup);

            // remove any open dropdown
            $('.widget-search-picker-modal .widget-search-picker-masthead-dropdown').removeClass('open');

            // attach event listeners to modal popup:
            // close click and apply filters
            $('body').on('click', '.widget-search-picker-modal-close', function(event, elem) {
                event.preventDefault();
                let _body = $(this).parents('.widget-search-picker-modal-content').find('.widget-search-picker-modal-body');
                // persistence for keyword
                $('input[name="qkeyword"]', _body).attr('value', $('input[name="qkeyword"]', _body).val());
                // cleaning open classes and toggle state
                $('#widget-search-picker-modal .widget-search-picker-masthead-dropdown').removeClass('open').find('.dropdown-options').removeAttr('style');
                // remove overflow constrain
                $('body').removeClass('widget-search-picker-modal-open');
                // serialisation of form
                let modalContent = $('#widget-search-picker-modal').find('.widget-search-picker-modal-body').html();
                $('#widget-search-picker-modal,.widget-search-picker-modal-backdrop').remove();
                $(_that).find('.widget-container>.inner-sleeve').html(modalContent);
                $(window).trigger("abacus:widget-search-picker-masthead:removed", elem);
            });

            // search click
            $('.widget-search-picker-modal').on('click', '.widget-search-picker-modal-btn-primary', function(event, elem) {
                event.preventDefault();
                $('.widget-search-picker-masthead-button>.button-search').trigger('click');
            });

            // reset filters click
            $('.widget-search-picker-modal').on('click', '.widget-search-picker-modal-btn-default', function(event, elem) {
                event.preventDefault();
                $('#widget-search-picker-modal input[name="qkeyword"]').attr('value', '').val('');
                $('#widget-search-picker-modal input[type="checkbox"]').prop('checked', false).removeAttr('checked');
                $('#widget-search-picker-modal .dropdown-option-checkbox.checked').removeClass('checked');
                $('#widget-search-picker-modal .widget-search-picker-masthead-dropdown .dropdown-label .counter').html('');
                document.querySelector('#widget-search-picker-modal .widget-search-picker-masthead-form').reset();
            });

            // dropdown header toggler panel to slide down / slide up
            $('.widget-search-picker-modal').on('click', '.widget-search-picker-masthead-dropdown .dropdown-label', function(event) {
                event.preventDefault();
                let _parent = $(this).parents('.widget-search-picker-masthead-dropdown');
                _parent.find('.dropdown-options').slideToggle(500, 'swing', function() {});
            });

            // keyword search enter click
            $('.widget-search-picker-modal input.text[type="search"]').keypress(function(event) {
                var keycode = (event.keyCode ? event.keyCode : event.which);
                if (keycode == '13') {
                    event.preventDefault();
                    event.stopPropagation();
                    $('.widget-search-picker-masthead-button>.button-search').trigger('click');
                }
            });
        };

        var createModal = function(content, title, closetext, primarybutton, secondarybutton) {
            var modalstring = `<div id="widget-search-picker-modal" class="widget-search-picker-modal fade in" tabindex="-1" role="dialog" aria-labelledby="widget-search-picker-modal-label">
          <div class="widget-search-picker-modal-dialog" tabIndex="-1" role="document">
            <div class="widget-search-picker-modal-content">
              <div class="widget-search-picker-modal-header">
                <button type="button" class="widget-search-picker-modal-close" data-dismiss="widget-search-picker-modal" tabindex="0" aria-label="${closetext}">${closetext}</button>
                <h4 id="widget-search-picker-modal-label" class="widget-search-picker-modal-title" tabindex="0">${title}</h4>
              </div>
              <div class="widget-search-picker-modal-body" tabindex="-1">
                ${content}
              </div>
              <div class="widget-search-picker-modal-footer">
                <button type="button" class="widget-search-picker-modal-btn-primary" data-dismiss="widget-search-picker-modal">${primarybutton}</button>
                <button type="button" class="widget-search-picker-modal-btn-default">${secondarybutton}</button>
              </div>
            </div>
          </div>
        </div>`;

            return modalstring;
        };

        // show modal click

        $(this.element).on('click', '.button-allfilters', function(event, elem) {
            event.preventDefault();
            var buttonAllfilters = $('.button-allfilters', _that);
            var title = (buttonAllfilters.attr('modal-title') || 'Search resources');
            var closetext = (buttonAllfilters.attr('modal-close') || 'Close');
            var searchtext = (buttonAllfilters.attr('modal-search') || 'Search');
            var cleartext = (buttonAllfilters.attr('modal-clear') || 'Clear all filters');

            // persistence for keyword
            $('input[name="qkeyword"]', _that.find('.widget-container>.inner-sleeve')).attr('value', $('input[name="qkeyword"]', _that.find('.widget-container>.inner-sleeve')).val());
            // serialisation of form
            var content = (_that.find('.widget-container>.inner-sleeve').html() || '');
            // remove any open dropdown
            $('.widget-search-picker-masthead-dropdown').removeClass('open');
            // show modal
            showModal(content, title, closetext, searchtext, cleartext);
            $('.widget-search-picker-modal-close').focus();

            $('.widget-search-picker-modal-footer .widget-search-picker-modal-btn-default').on('focusout', function(event) {
                $('.widget-search-picker-modal').remove();
                $('.widget-search-picker-modal-backdrop').remove();
            })
        });
    }
}

export { WidgetSearchPicker };


// WEBPACK FOOTER //
// ./Javascript/core/classes/widgets/widget-search-picker.class.js